import { createExclusionGroupFcmConfig } from '../shared/builders/exclusionGroup';
import type { FcmConfig } from '../shared/types';

const { name, normalizer, defaultValue } = createExclusionGroupFcmConfig('promote_page_exclusion_group');

export const FCM_PROMOTE_PAGE_EXCLUSION_GROUP: FcmConfig<typeof defaultValue, typeof defaultValue> = {
	name,
	normalizer,
	defaultValue,
	owner: 'squad-koi',
	scope: 'corgi-front-end',
	context: 'Promote page',
	description:
		'Exclusion group for mutually exclusive Promote page experiments (CHANGE-96728): keeps a session bucketed into at most one of its member experiments. Members and their weights are managed on this admin page, not in code. An experiment only checks itself against this group when its own exclusion_group_experiment_id is set (unset means it runs unconditionally, bypassing the group). Defaults to no members (all member experiments effectively disabled) until weights are set via this admin page.',
	template: {
		members: [],
	},
};
